(function () {
    'use strict';

    angular
        .module('elogbooks.admin.job-requisites')
        .controller('JobRequisitesPartnershipsEditController', JobRequisitesPartnershipsEditController);

    JobRequisitesPartnershipsEditController.$inject = ['$scope', '$state', '$stateParams', '$q', 'messenger', 'apiClient', 'lodash', 'jobRequisiteResponse', 'selectedPartnershipCollectionResponse', 'siteCollectionResponse', 'rootResourceResponse'];

    function JobRequisitesPartnershipsEditController ($scope, $state, $stateParams, $q, messenger, apiClient, lodash, jobRequisiteResponse, selectedPartnershipCollectionResponse, siteCollectionResponse, rootResourceResponse) {
        var vm = this;

        vm.jobRequisite = jobRequisiteResponse;
        vm.selectedItems = selectedPartnershipCollectionResponse ? selectedPartnershipCollectionResponse.partnerships : [];

        vm.siteSearchLink = rootResourceResponse.getLink('sites');
        vm.siteSearchParams = {
            status: 'active',
            limit: 30,
            datagroup: 'list',
            excludeSitesFullyLinkedToJRId: jobRequisiteResponse.id
        };
        vm.siteCollectionResponse = siteCollectionResponse;
        vm.sites = siteCollectionResponse.sites;
        vm.selectedSite = null;
        vm.siteFilter = null;
        vm.sitesHtmlModel = {
            isLoading: false,
            selected: [],
            options: [],
            hasMoreOptions: (siteCollectionResponse.page || 1) < (siteCollectionResponse.pages || 1) && !!siteCollectionResponse.getLink('next'),
            loadNext: loadMoreSites
        };

        vm.serviceProviders = [];
        vm.serviceProvidersCollectionResponse = null;
        vm.serviceProvidersHtmlModel = {
            isLoading: false,
            selected: [],
            options: [],
            hasMoreOptions: false,
            loadNext: loadMoreServiceProviders
        };

        vm.revoke = revokeAction;
        vm.grant = grantAction;
        vm.update = updateAction;

        refreshSiteOptions();

        $scope.$watchCollection('vm.sitesHtmlModel.selected', function(selected) {
            if (selected && selected.length > 1) {
                vm.sitesHtmlModel.selected = selected.slice(0, 1);
                return;
            }

            var site = selected && selected.length ? selected[0].site : null;

            if (site && (!vm.selectedSite || vm.selectedSite.getLink('self') !== site.getLink('self'))) {
                vm.selectedSite = site;
                loadServiceProviders();
            } else if (!site) {
                vm.selectedSite = null;
            }
        });

        $scope.$watch('vm.siteFilter', lodash.debounce(function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            searchSites();
        }, 250));

        $scope.$watch('vm.serviceProviderFilter', lodash.debounce(function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            searchServiceProviders();
        }, 250));

        function refreshSiteOptions() {
            vm.sitesHtmlModel.options = lodash.map(vm.sites, function(site) {
                return {
                    id: site.getLink('self'),
                    value: site.name,
                    site: site
                };
            });
        }

        function searchSites() {
            vm.sitesHtmlModel.isLoading = true;

            var params = lodash.extend({}, vm.siteSearchParams, { siteName: vm.siteFilter });

            apiClient.get(vm.siteSearchLink, params).then(function(response) {
                if (!response) {
                    vm.sitesHtmlModel.isLoading = false;
                    return messenger.error('REQUEST_ERROR');
                }

                vm.siteCollectionResponse = response;
                vm.sites = response.sites;
                vm.sitesHtmlModel.hasMoreOptions = (response.page || 1) < (response.pages || 1) && !!response.getLink('next');
                vm.sitesHtmlModel.isLoading = false;
                refreshSiteOptions();
            });
        }

        function loadMoreSites() {
            if (!vm.siteCollectionResponse || !vm.siteCollectionResponse.getLink('next')) {
                vm.sitesHtmlModel.hasMoreOptions = false;
                return $q.resolve();
            }

            return apiClient.get(vm.siteCollectionResponse.getLink('next')).then(function(response) {
                if (!response) {
                    vm.sitesHtmlModel.hasMoreOptions = false;
                    return messenger.error('REQUEST_ERROR');
                }

                vm.sites = vm.sites.concat(response.sites);
                vm.siteCollectionResponse = response;
                vm.sitesHtmlModel.hasMoreOptions = (response.page || 1) < (response.pages || 1) && !!response.getLink('next');
                refreshSiteOptions();
            });
        }

        function excludeSelectedItems(partnerships) {
            return lodash.reject(partnerships, function(partnership) {
                return lodash.find(vm.selectedItems, function(item) {return item._links.self.href == partnership._links.self.href;});
            });
        }

        function refreshServiceProviderOptions() {
            vm.serviceProvidersHtmlModel.options = lodash.map(vm.serviceProviders, function(partnership) {
                return {
                    id: partnership._links.self.href,
                    value: partnership._links.serviceprovider.title,
                    partnership: partnership
                };
            });
        }

        function loadServiceProviders() {
            vm.serviceProviderFilter = null;
            searchServiceProviders();
        }

        function searchServiceProviders() {
            if (!vm.selectedSite) {
                return;
            }

            var params = { serviceProvidersStatus: 'active', name: vm.serviceProviderFilter };

            vm.serviceProvidersHtmlModel.isLoading = true;

            apiClient.get(vm.selectedSite.getLink('partnerships'), params).then(function(response) {
                if (!response) {
                    vm.serviceProvidersHtmlModel.isLoading = false;
                    return messenger.error('REQUEST_ERROR');
                }

                vm.serviceProviders = excludeSelectedItems(response.partnerships);
                vm.serviceProvidersCollectionResponse = response;
                vm.serviceProvidersHtmlModel.hasMoreOptions = (response.page || 1) < (response.pages || 1) && !!response.getLink('next');
                vm.serviceProvidersHtmlModel.isLoading = false;
                refreshServiceProviderOptions();
            });
        }

        function loadMoreServiceProviders() {
            if (!vm.serviceProvidersCollectionResponse || !vm.serviceProvidersCollectionResponse.getLink('next')) {
                vm.serviceProvidersHtmlModel.hasMoreOptions = false;
                return $q.resolve();
            }

            return apiClient.get(vm.serviceProvidersCollectionResponse.getLink('next')).then(function(response) {
                if (!response) {
                    vm.serviceProvidersHtmlModel.hasMoreOptions = false;
                    return messenger.error('REQUEST_ERROR');
                }

                vm.serviceProviders = vm.serviceProviders.concat(excludeSelectedItems(response.partnerships));
                vm.serviceProvidersCollectionResponse = response;
                vm.serviceProvidersHtmlModel.hasMoreOptions = (response.page || 1) < (response.pages || 1) && !!response.getLink('next');
                refreshServiceProviderOptions();
            });
        }

        function revokeAction(partnership) {
            vm.selectedItems = lodash.difference(vm.selectedItems, [partnership]);

            if (vm.selectedSite && partnership._links.site.href === vm.selectedSite.getLink('self')) {
                vm.serviceProviders = lodash.union(vm.serviceProviders, [partnership]);
                refreshServiceProviderOptions();
            }
        }

        function grantAction() {
            var chosen = lodash.map(vm.serviceProvidersHtmlModel.selected, 'partnership');

            if (!chosen.length) {
                return;
            }

            vm.serviceProviders = lodash.difference(vm.serviceProviders, chosen);
            vm.selectedItems = lodash.union(vm.selectedItems, chosen);
            refreshServiceProviderOptions();
        }

        function updateAction() {
            var data = {
                _links: {
                    partnerships: [
                    ]
                }
            };

            lodash.each(vm.selectedItems, function(user){
                data._links.partnerships.push(user._links.self);
            });

            apiClient.create(vm.jobRequisite.getLink('partnerships'), data).then(function(response){
                if (response) {
                    $state.go('^', $stateParams, { reload: true }).then(function () {
                        messenger.success('JOB_REQUISITE_PARTNERSHIP_ADDED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                }
            });
        }
    }

})();
